import { render, staticRenderFns } from "./UseRateInfoForm.vue?vue&type=template&id=45caf810&"
import script from "./UseRateInfoForm.vue?vue&type=script&lang=js&"
export * from "./UseRateInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports